import {APIService} from "../../common/APIService";
import {Contact, ContactSex, ContactType} from "../../dto/Contact";
import {Team} from "../../dto/Team";

export class TeamService extends APIService {
  public async browse(date: Date) {
    const json = await this.getJson<{ data: object[] }>(`teams?date=${Math.floor(date.getTime() / 1000)}`)
    return json.data.map(Team.fromJson)
  }
}